import { Link } from 'react-router-dom';

const urgencyStyles = {
  normal: 'border-l-green-500 bg-green-50',
  high: 'border-l-orange-500 bg-orange-50',
  critical: 'border-l-red-500 bg-red-50',
};

const urgencyBadge = {
  normal: 'bg-green-100 text-green-800',
  high: 'bg-orange-100 text-orange-800',
  critical: 'bg-red-100 text-red-800',
};

function JobCard({ job, orderNumber, isDragging, blockNavigation }) {
  const property = job.properties;
  const tasks = job.job_tasks || [];

  const className = `block border-l-4 rounded-lg shadow-sm p-4 hover:shadow-md transition-shadow relative ${
    urgencyStyles[job.urgency_flag] || urgencyStyles.normal
  } ${isDragging ? 'opacity-50' : ''}`;

  const Wrapper = blockNavigation ? 'div' : Link;
  const wrapperProps = blockNavigation ? {} : { to: `/jobs/${job.id}/edit` };

  return (
    <Wrapper
      {...wrapperProps}
      className={className}
    >
      {orderNumber && (
        <div className="absolute -top-2 -left-1 w-6 h-6 bg-brand-black text-white rounded-full flex items-center justify-center text-xs font-bold shadow">
          {orderNumber}
        </div>
      )}
      <div className="flex justify-between items-start mb-2">
        <div>
          <h3 className="font-semibold text-gray-900">
            {property?.name || 'Unknown Property'}
            {job.unit_number && (
              <span className="text-gray-600"> - Unit {job.unit_number}</span>
            )}
          </h3>
          {job.job_type_text && (
            <p className="text-sm text-gray-600">{job.job_type_text}</p>
          )}
        </div>
        <span
          className={`px-2 py-1 text-xs font-medium rounded-full capitalize ${
            urgencyBadge[job.urgency_flag] || urgencyBadge.normal
          }`}
        >
          {job.urgency_flag}
        </span>
      </div>

      {tasks.length > 0 && (
        <div className="mt-3">
          <p className="text-xs font-medium text-gray-500 uppercase mb-1">Tasks</p>
          <ul className="text-sm text-gray-700 space-y-1">
            {tasks.slice(0, 3).map((task) => (
              <li key={task.id} className="flex items-center">
                <span className="w-4 h-4 border border-gray-400 rounded mr-2 flex-shrink-0" />
                {task.task_description}
              </li>
            ))}
            {tasks.length > 3 && (
              <li className="text-gray-500 italic">
                +{tasks.length - 3} more task{tasks.length - 3 > 1 ? 's' : ''}
              </li>
            )}
          </ul>
        </div>
      )}

      {job.special_notes && (
        <div className="mt-3 pt-3 border-t border-gray-200">
          <p className="text-xs font-medium text-gray-500 uppercase mb-1">Notes</p>
          <p className="text-sm text-gray-700">{job.special_notes}</p>
        </div>
      )}
    </Wrapper>
  );
}

export default JobCard;
